import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'chrono',
  standalone: true,
})
export class ChronoPipe implements PipeTransform {
  transform(value: number, format: 'full' | 'adaptive' | 'short' = 'full'): string {
    const h: number = Math.floor(value / 3600);
    const m: number = Math.floor((value % 3600) / 60);
    const s: number = Math.floor(value % 60);
    const paddedSeconds: string = String(s).padStart(2, '0');

    if (format === 'short') {
      return `${String(Math.floor(value / 60)).padStart(2, '0')}:${paddedSeconds}`;
    }

    if (format === 'adaptive' && h === 0) {
      return `${String(m).padStart(2, '0')}:${paddedSeconds}`;
    }

    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${paddedSeconds}`;
  }
}
